/* eslint-disable */
const $ = jQuery.noConflict();
import 'select2/dist/js/select2.full.js';

'use strict';
const Select2 = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$select: $('.js-select'),
	$selectDefault: $('.js-select-default'),
	$multielect: $('.js-multi-select'),
	$productAttrOptionSelect: $('.js-product-attr-option-select'),
	$productAttrOptionColor: $('.js-product-attr-option-color'),
	$selectFormGroup: $('.js-select-form-group'),
	$selectInPopup: $('.js-select-popup'),

	/** @description Initialize */
	init: function() {
		this.select2();
		this.initWishlistModal();
		this.initPdfCatalogPopup();
	},

	select2: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		Select2.$select.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'custom-class',
		});
		Select2.$selectDefault.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'select-default',
		});
		Select2.$multielect.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'custom-class',
			multiple: true
		});
		function formatState(state) {
			if (!state.id) { return state.text; }
			let $state = $(
				'<span><img src="' + $(state.element).attr('data-src') + '" class="select-img" />' + state.text + '</span>'
			);
			return $state;
		}
		Select2.$productAttrOptionSelect.select2({
			width: 'style',
			dropdownCssClass: 'product-attr-option-select-dropdown',
			minimumResultsForSearch: Infinity,
			templateResult: formatState,
			templateSelection: formatState
		});
		Select2.$productAttrOptionColor.select2({
			width: 'style',
			dropdownCssClass: 'product-attr-option-select-color',
			minimumResultsForSearch: Infinity,
			templateResult: formatState,
			templateSelection: formatState
		});
		Select2.$selectFormGroup.select2({
			minimumResultsForSearch: Infinity,
			width: 'style',
			dropdownCssClass: 'form-group-select',
			placeholder: ''
		});
		Select2.$selectInPopup.select2({
			minimumResultsForSearch: Infinity,
			width: 'style',
			dropdownCssClass: 'form-group-select',
			dropdownParent: $('.js-get-certified-form-popup'),
		});
	},

	/**
	 * @description Init Select2 for wishlist modal selects
	 */
	initWishlistModal: function() {
		$(document).on('wishlistmodal:open', () => {
			const $modal = $('.woocommerce-wishlist-modal');

			// main select
			const $wishlistSelect = $modal.find('#woocommerce-wishlist-select');
			if ($wishlistSelect.length) {
				if ($wishlistSelect.hasClass('select2-hidden-accessible')) {
					$wishlistSelect.select2('destroy');
				}
				$wishlistSelect.select2({
					minimumResultsForSearch: -1,
					width: 'style',
					dropdownCssClass: 'woocommerce-wishlist-select',
					selectionCssClass: 'woocommerce-wishlist-select__selection',
					dropdownParent: $modal,
				});
			}

			// visibility select
			const $wishlistVisibility = $modal.find('#woocommerce-wishlist-visibility');
			if ($wishlistVisibility.length) {
				if ($wishlistVisibility.hasClass('select2-hidden-accessible')) {
					$wishlistVisibility.select2('destroy');
				}
				$wishlistVisibility.select2({
					minimumResultsForSearch: -1,
					width: 'style',
					dropdownCssClass: 'woocommerce-wishlist-visibility',
					selectionCssClass: 'woocommerce-wishlist-visibility__selection',
					dropdownParent: $modal,
				});
			}
		});
	},

	/**
	 * @description Init Select2 for all selects inside WooCommerce PDF Catalog popup
	 */
	initPdfCatalogPopup: function() {
	// Buttons that trigger the popup (general + wishlist versions)
	const openSelector =
		'.woocommerce-pdf-catalog-email-button, .woocommerce-pdf-catalog-email-wishlist-button';

		// When the popup is opened (on click), wait shortly and then init Select2
		$(document).on('click', openSelector, function() {
			setTimeout(() => {
			const $popup = $('.woocommerce-pdf-catalog-popup');

			// 1) Catalog type select
			const $catalogType = $popup.find(
				'select.woocommerce-pdf-catalog-email-type, select[name="woocommerce_pdf_catalog_email_type"]'
			);
			if ($catalogType.length) {
				if ($catalogType.hasClass('select2-hidden-accessible')) {
				$catalogType.select2('destroy');
				}
				$catalogType.select2({
					minimumResultsForSearch: -1,
					width: 'style',
					dropdownCssClass: 'pdf-catalog-email-type',
					selectionCssClass: 'pdf-catalog-email-type__selection',
					dropdownParent: $popup,
				});
			}

			// 2) Category select (only shown for "Category Catalog")
			const $catalogCategory = $popup.find(
				'select.woocommerce-pdf-catalog-email-category, select[name="woocommerce_pdf_catalog_category"]'
			);
			if ($catalogCategory.length) {
				if ($catalogCategory.hasClass('select2-hidden-accessible')) {
					$catalogCategory.select2('destroy');
				}
				$catalogCategory.select2({
					minimumResultsForSearch: -1,
					width: 'style',
					dropdownCssClass: 'pdf-catalog-email-category',
					selectionCssClass: 'pdf-catalog-email-category__selection',
					dropdownParent: $popup,
				});
			}

			// 3) Wishlist select (only shown for "Wishlist Catalog")
			const $catalogWishlist = $popup.find(
				'select.woocommerce-pdf-catalog-email-wishlist, select[name="woocommerce_pdf_catalog_wishlist"]'
			);
			if ($catalogWishlist.length) {
				if ($catalogWishlist.hasClass('select2-hidden-accessible')) {
					$catalogWishlist.select2('destroy');
				}
				$catalogWishlist.select2({
					minimumResultsForSearch: -1,
					width: 'style',
					dropdownCssClass: 'pdf-catalog-email-wishlist',
					selectionCssClass: 'pdf-catalog-email-wishlist__selection',
					dropdownParent: $popup,
				});
			}
			}, 50); // short delay to ensure popup HTML is rendered
		});
	},
};

export default Select2;
